// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Folder, FileUp, X } from 'lucide-react';

function groupByFolder(files) {
  return files.reduce((acc, item) => {
    const parts = item.relativePath.split('/');
    if (parts.length > 1) {
      const folder = parts.slice(0, -1).join('/');
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(item);
    } else {
      if (!acc._root) acc._root = [];
      acc._root.push(item);
    }
    return acc;
  }, {});
}

export default function SelectedFilesList({ files, uploadMode, onRemove }) {
  if (files.length === 0) return null;
  const grouped = groupByFolder(files);

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">
        {uploadMode === 'folder' ? 'Estrutura da pasta' : 'Arquivos selecionados'} ({files.length})
      </Label>
      <div className="space-y-1 max-h-40 overflow-y-auto border border-slate-200 rounded-lg p-2">
        {Object.entries(grouped).map(([folder, folderFiles]) => (
          <div key={folder} className="space-y-1">
            {folder !== '_root' && (
              <div className="flex items-center gap-2 text-xs font-medium text-slate-600 py-1">
                <Folder className="w-3 h-3 text-amber-500" />
                <span>{folder}/</span>
              </div>
            )}
            {folderFiles.map((item) => {
              const globalIndex = files.indexOf(item);
              return (
                <div
                  key={`file-${item.file.name}-${globalIndex}`}
                  className={`flex items-center justify-between p-1.5 bg-slate-50 rounded text-xs ${
                    folder !== '_root' ? 'ml-4' : ''
                  }`}
                >
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    <FileUp className="w-3 h-3 text-slate-400 flex-shrink-0" />
                    <span className="text-slate-700 truncate">{item.file.name}</span>
                    <span className="text-slate-400 flex-shrink-0">
                      {(item.file.size / 1024).toFixed(1)} KB
                    </span>
                  </div>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="flex-shrink-0 h-5 w-5"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemove(globalIndex);
                    }}
                  >
                    <X className="w-3 h-3" />
                  </Button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
